import { PRODUCT_SEARCH_INFO } from '@@partner:graphql/shortcuts'
import type { Product } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql } from '@apollo/client'

export interface SearchProductsWithFilterQuery {
  searchProducts: {
    edges: Product[]
  }
}

export interface SearchProductsWithFilterQueryVariables {
  filter: any // TODO: add typing here
  shop_id: GQL_ID
  limit?: number
  page?: number
}

export const GQL_QUERY_SEARCH_PRODUCTS_WITH_FILTER = gql`
  query($filter: SearchQuery!, $shop_id: ID!, $limit: Int, $page: Int) {
    searchProducts: searchProductsWithFilter(
      searchQuery: $filter
      shop_id: $shop_id
      _limit: $limit
      _page: $page
    ) {
      edges {
        ${PRODUCT_SEARCH_INFO}
      }
    }
  }
`
